import "./Avatar.css";

/** "Laura Navarro" -> "LN", "skor" -> "S" */
export const getInitials = (name?: string | null) =>
  (name ?? "")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((word) => word.charAt(0))
    .join("")
    .toUpperCase();

export interface AvatarProps {
  /** full name; the initials are taken from it */
  name?: string | null;
  /** picture URL; shown instead of the initials */
  src?: string | null;
  /** sm 28, md 36 (default), lg 44, xl 72 (profile header) */
  size?: "sm" | "md" | "lg" | "xl";
  /** "ink" on light backgrounds (default), "onDark" on the dark side panel,
      "lime" = lime circle, e.g. in a dark modal header */
  tone?: "ink" | "onDark" | "lime";
  className?: string;
}

/**
 * Round picture or initials for a person or workspace.
 * Example: <Avatar name="Laura Navarro" />
 */
const Avatar = ({
  name,
  src,
  size = "md",
  tone = "ink",
  className = "",
}: AvatarProps) => (
  <span
    className={`ds-avatar ds-avatar--${size} ${
      tone !== "ink" ? `ds-avatar--${tone}` : ""
    } ${className}`.trim()}
    aria-hidden="true"
  >
    {src ? <img src={src} alt="" /> : getInitials(name)}
  </span>
);

export default Avatar;
